import { createStore } from "vuex";
import prodJson from "@/assets/data/prodItems.json";
import medJson from "@/assets/data/medItems.json";
import createPersistedState from "vuex-persistedstate";

export default createStore({
  state: {
    money: 0,
    gems: 0,
    date: new Date(),
    time: 0,
    timeMulti: 1,
    prodItems: [],
    medItems: [],
    vaccineStatus: "Locked", // Locked, Started, Finished, Unlocked
    vaccineDevTime: 10,
    tabSwitch: false,
    population: 7857251139,
    healed: 0,
    infected: 1,
    infectedForDead: 1,
    dead: 0,
    intervalTime: 40000,
    lockdown: false,
    lockTime: 7,
    finalDate: "",
    gamePause: false,
    gameOver: false,
    interval: {},
    gamesCount: 0,
    autoPause: false,
    tutStep: 0,
    showNavBar: false,
    music: "not",
    qa: false,
    v: "0.1.7",
  },
  mutations: {
    addMoney(state, val) {
      state.money = state.money + val;
    },
    setPopulation(state, val) {
      state.population = val;
    },

    addHealed(state, val) {
      state.healed = state.healed + val;
    },

    addDead(state, val) {
      state.dead = state.dead + val;
    },

    setInfected(state, val) {
      state.infected = val;
    },

    setInfectedForDead(state, val) {
      state.infectedForDead = val;
    },

    minusMoney(state, val) {
      state.money = state.money - val;
    },

    levelProdUp(state, index) {
      state.prodItems[index].level++;
    },

    levelMedUp(state, index) {
      state.medItems[index].level++;
    },

    enableProdItem(state, index) {
      state.prodItems[index].enabled = true;
    },

    enableMedItem(state, index) {
      state.medItems[index].enabled = true;
    },

    addProdItem(state, item) {
      state.prodItems.push(item);
    },

    addMedItem(state, item) {
      state.medItems.push(item);
    },

    loadProdItems(state, items) {
      state.prodItems = items;
    },

    setVaccineStatus(state, status) {
      state.vaccineStatus = status;
    },

    tabToggle(state) {
      state.tabSwitch = !state.tabSwitch;
    },

    multiply(state, multiple) {
      state.money = state.money * multiple;
    },

    setLockdown(state, bool) {
      state.lockdown = bool;
    },

    setLockdownTime(state, time) {
      state.lockTime = time;
    },

    setMulti(state, val) {
      state.timeMulti = val;
    },

    setFinals(state, date) {
      state.finalDate = date;
      state.gamePause = true;
      state.gameOver = true;
    },

    setPause(state, bool) {
      state.gamePause = bool;
    },

    startTick(state) {
      let tickTime = Number(state.intervalTime / state.timeMulti);
      state.gamePause = false;

      state.interval = setInterval(() => {
        ++state.time;
      }, tickTime);
    },

    stopTick(state) {
      state.gamePause = true;
      clearInterval(state.interval);
    },

    plusTutStep(state) {
      ++state.tutStep;
    },

    setQa(state, bool) {
      state.qa = bool;
    },

    setAutopause(state, bool) {
      state.autoPause = bool;
    },

    showNavBar(state) {
      state.showNavBar = true;
    },

    musicSwitch(state, bool) {
      state.music = bool;
    },

    resetGame(state) {
      state.gameOver = false;
      state.population = 7857251139;
      state.vaccineStatus = "Locked";
      state.lockdown = false;
      state.infected = 1;
      state.infectedForDead = 1;
      state.dead = 0;
      state.time = 0;
      state.healed = 0;
      state.prodItems = [];
      state.medItems = [];
      state.tutStep = 0;
      state.showNavBar = false;
      // state.music = "not"; // dont' forget
      // state.vaccineDevTime = 300; // dont' forget
    },
  },
  actions: {
    loadProdItem({ commit }, index) {
      const item = prodJson.items[index];
      // wtf...
      item.level = 1;
      if (index !== 0) {
        item.enabled = false;
      }
      commit("addProdItem", item);
    },

    loadMedItem({ commit }, index) {
      const item = medJson.items[index];

      item.level = 1;
      if (index !== 0) {
        item.enabled = false;
      }

      commit("addMedItem", item);
    },
  },
  modules: {},
  getters: {
    prodItemsCount: (state) => {
      return state.prodItems.length;
    },

    medItemsCount: (state) => {
      return state.medItems.length;
    },
  },
  plugins: [
    createPersistedState({
      key: "killah-0",
      paths: [
        "money",
        "gems",
        "date",
        "time",
        "prodItems",
        "medItems",
        "vaccineStatus",
        "vaccineDevTime",
        "population",
        "healed",
        "infected",
        "infectedForDead",
        "dead",
        "intervalTime",
        "lockdown",
        "lockTime",
        "finalDate",
        "gameOver",
        "interval",
        "gamesCount",
        "tutStep",
        "autoPause",
        "showNavBar",
        "music",
        "qa",
      ],
    }),
  ],
});
